const constants = {
  REQUEST_ADRESS: 'https://www.googleapis.com/books/v1/volumes',
  API_KEY: process.env.REACT_APP_API_KEY,
  FETCH_ERROR_MESSAGE: 'Ошибка запроса к серверу. Попробуйте позднее',
  IMG_PLACEHOLDER: 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png',
  TITLE_PLACEHOLDER: 'Название недоступно',
  CATEGORY_PLACEHOLDER: 'без категории',
  AUTHOR_PLACEHOLDER: 'Автор неизвестен',
  DESCRIPTION_PLACEHOLDER: 'Описание недоступно',
};

export default constants;
